import { useState, useCallback } from 'react';
import type { ISelectOption } from '@creditflowresearch/uilib/Select';
import type {
  IFilterContext,
  TStringArrayKeys,
} from '@/creditflowresearch/application/BondScreener/createUseMultiSelectFilter';

interface IUseSearchSelectFilterProps<T> {
  filterKey: TStringArrayKeys<T>,
  getId?: (option: ISelectOption) => string,
}

interface IUseSearchSelectFilterReturn {
  selectedOptions: ISelectOption[],
  onChange: (selected: ISelectOption[]) => void,
}

const defaultGetId = (option: ISelectOption): string => String(option.value);

const createUseSearchSelectFilter = <T extends Record<string, unknown>>(
  useFilterContext: () => IFilterContext<T>,
) => (
  { filterKey, getId = defaultGetId }: IUseSearchSelectFilterProps<T>,
): IUseSearchSelectFilterReturn => {
  const { setLocalFilters } = useFilterContext();
  const [selectedOptions, setSelectedOptions] = useState<ISelectOption[]>([]);

  const onChange = useCallback((selected: ISelectOption[]): void => {
    setSelectedOptions(selected);
    setLocalFilters((prev) => ({ ...prev, [filterKey]: selected.map(getId) }));
  }, [filterKey, setLocalFilters, getId]);

  return { selectedOptions, onChange };
};

export { createUseSearchSelectFilter };
export type { IUseSearchSelectFilterProps, IUseSearchSelectFilterReturn };
